var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-empty */
import React, { useEffect } from 'react';
import { Modal } from 'pcln-modal';
import { DefaultModalHeader } from './DefaultModalHeader';
import { ChatDialogMainContentSection } from './ChatDialogContent';
import { ChatbotDataContext } from './context/ChatbotDataContext';
var ChatDialog = function (props) {
    useEffect(function () {
        try {
            var modal = document.querySelector("div[aria-label=\"".concat(props.modalAriaLabel, "\"]"));
            if (modal && props.isMobile) {
                modal.style.height = 'calc(100% - 20px)'; // override the default 100vh height value in Modal to ensure behavior on mobile
                modal.style.borderBottomRightRadius = '0px';
                modal.style.borderBottomLeftRadius = '0px';
                modal.style.marginTop = '20px';
            }
            var modalContentWrapper = document.querySelector("div[aria-label=\"Travel Bot Chat Dialog Modal\"] > div >div:nth-child(2)");
            if (modalContentWrapper) {
                modalContentWrapper.style.borderRadius = '0px';
                modalContentWrapper.style.height = '0';
            }
            if (props.onChatDialogRendered) {
                props.onChatDialogRendered();
            }
        }
        catch (err) { }
    }, []);
    return React.createElement(ChatDialogMainContentSection, null);
};
/**
 * PclnUcChatBot
 * @public
 */
export var PclnUcChatBot = function (props) {
    var pclnModalProps = props.pclnModalProps, isChatBoxOpened = props.isChatBoxOpened, onClose = props.onClose, modalHeader = props.modalHeader, _a = props.modalAriaLabel, modalAriaLabel = _a === void 0 ? 'Travel Bot Chat Dialog Modal' : _a, onDefaultModalHeaderRendered = props.onDefaultModalHeaderRendered, _b = props.zIndex, zIndex = _b === void 0 ? 100 : _b, _c = props.fullScreen, fullScreen = _c === void 0 ? true : _c, setCachedMessages = props.setCachedMessages, setCachedPrompts = props.setCachedPrompts, cachedMessages = props.cachedMessages, cachedPrompts = props.cachedPrompts, submitChatMessagesPayload = props.submitChatMessagesPayload, handleMarkerResponse = props.handleMarkerResponse, fetchRequestOptions = props.fetchRequestOptions, isMobile = props.isMobile, _d = props.markerComponents, markerComponents = _d === void 0 ? {} : _d, defaultHeaderBadge = props.defaultHeaderBadge, onChatDialogRendered = props.onChatDialogRendered, logFirstMessageSubmitted = props.logFirstMessageSubmitted, logCustomerCarePhoneNumberDisplayed = props.logCustomerCarePhoneNumberDisplayed, logCustomerCarePhoneNumberClicked = props.logCustomerCarePhoneNumberClicked, quickActions = props.quickActions;
    var chatDialogMainContentSectionProps = {
        setCachedMessages: setCachedMessages,
        setCachedPrompts: setCachedPrompts,
        cachedMessages: cachedMessages,
        cachedPrompts: cachedPrompts,
        submitChatMessagesPayload: submitChatMessagesPayload,
        handleMarkerResponse: handleMarkerResponse,
        fetchRequestOptions: fetchRequestOptions,
        markerComponents: markerComponents,
        logFirstMessageSubmitted: logFirstMessageSubmitted,
        logCustomerCarePhoneNumberDisplayed: logCustomerCarePhoneNumberDisplayed,
        logCustomerCarePhoneNumberClicked: logCustomerCarePhoneNumberClicked,
        quickActions: quickActions,
        isMobile: isMobile,
    };
    return (React.createElement(Modal, __assign({ ariaLabel: modalAriaLabel, imgMode: true, isOpen: isChatBoxOpened, fullScreen: fullScreen, bg: 'white', zIndex: zIndex, width: '100%', height: '100%', header: modalHeader ? (modalHeader) : (React.createElement(DefaultModalHeader, { defaultHeaderBadge: defaultHeaderBadge, onDefaultModalHeaderRendered: onDefaultModalHeaderRendered, onClose: onClose })), disableCloseButton: true, enableOverflow: false, verticalAlignment: 'top' }, pclnModalProps),
        React.createElement(ChatbotDataContext.Provider, { value: chatDialogMainContentSectionProps },
            React.createElement(ChatDialog, { isMobile: isMobile, modalAriaLabel: modalAriaLabel, onChatDialogRendered: onChatDialogRendered }))));
};
//# sourceMappingURL=PclnUcChatBot.js.map